import { createFileRoute, useParams, Link } from '@tanstack/react-router'
import { ArrowLeft, Loader2 } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { useProjects } from '@/hooks/useProjects'
import { SerpDashboard } from '@/components/serp/SerpDashboard'

export const Route = createFileRoute('/_authenticated/projekty/$projectId/serp')({
  component: SerpPage,
})

function SerpPage() {
  const { projectId } = useParams({
    from: '/_authenticated/projekty/$projectId/serp',
  })
  const { data: projects, isLoading } = useProjects()
  const project = projects?.find((p) => p.id === projectId)

  if (isLoading) {
    return (
      <div className="flex items-center justify-center py-12">
        <Loader2 className="h-8 w-8 animate-spin" style={{ color: 'var(--text-muted)' }} />
      </div>
    )
  }

  if (!project) {
    return (
      <div className="space-y-4">
        <p style={{ color: 'var(--text-muted)' }}>Nie znaleziono projektu.</p>
        <Button variant="outline" asChild>
          <Link to="/projekty">
            <ArrowLeft className="mr-2 h-4 w-4" />
            Wróć do projektów
          </Link>
        </Button>
      </div>
    )
  }

  return (
    <SerpDashboard
      projectId={projectId}
      projectName={project.name}
      projectUrl={project.url}
    />
  )
}
